// @flow
import { matchSize } from 'utils/responsive';
import smoothscroll from 'smoothscroll-polyfill';
import invariant from 'invariant';

// Kick off the polyfill
if (typeof window !== 'undefined') {
  smoothscroll.polyfill();
}

// Adapted from https://plainjs.com/javascript/styles/get-the-position-of-an-element-relative-to-the-document-24/
function calculateOffset(el) {
  const rect = el.getBoundingClientRect();
  invariant(document.documentElement, 'document.documentElement not defined');
  const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
}

// Scroll element into view. Padding is space above the element
const scrollIntoView = (
  element?: ?Element,
  {
    padding,
    noTransition
  }: {
    padding?: number,
    noTransition?: boolean
  } = {}
) => {
  const offset = element ? calculateOffset(element) : { top: 0 };

  let offsetAboveElement = padding || 32;
  if (matchSize({ xs: true, sm: true, md: true })) {
    // compensate for the sticky page header on mobile
    offsetAboveElement += 66;
  } else if (matchSize({ lg: true, xl: true }) && offset.top > 0) {
    offsetAboveElement += 96;
  }
  window.scrollTo({
    top: offset.top - offsetAboveElement,
    left: 0,
    behavior: noTransition ? 'auto' : 'smooth'
  });
};

export default scrollIntoView;

export const scrollToHash = (
  hash?: string,
  options?: {
    padding?: number,
    noTransition?: boolean
  }
) => {
  if (hash && hash.length > 0) {
    const id = hash.replace('#', '');
    const el = document.getElementById(id);
    if (el) {
      scrollIntoView(el, options);
    }
  }
};
